import React, { useContext, useEffect } from "react";
import {useState} from 'react'
import { AppContext } from '../../App'
import { useAuth } from "react-oidc-context"


export default function CerrarSesion(){      

  const {state, dispatch} = useContext(AppContext);

  const auth = useAuth();

  const logoutEvent = (evt) => {
          
    evt.preventDefault();    
    //auth.removeUser();   
    ////auth.clearStaleState();
    ////auth.revokeTokens();       
    ////auth.signOutRedirect();
        
    var sessionItem_OIDC_USER = `oidc.user:${process.env.REACT_APP_OIDC_AUTHORITY}:${process.env.REACT_APP_OIDC_CLIENT_ID}`;    
    sessionStorage.removeItem(sessionItem_OIDC_USER);
    //sessionStorage.removeItem('oidc.user:https://descar.admon-cfnavarra.es/ateka_estable:htn_sistemarepresentaciones_web');

    var avisadoKey = `${process.env.REACT_APP_AVISADO}`;
    sessionStorage.removeItem(avisadoKey);

    const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;//newPathname;
    var encodedUri = encodeURIComponent(updatedUrl);//(updatedUrl + '/logout');
    //var encodedUri = encodeURIComponent("https://www.google.com");//(updatedUrl + '/logout');
    var url = `${process.env.REACT_APP_OIDC_AUTHORITY}/connect/endsession?id_token_hint=${auth.user?.id_token}&post_logout_redirect_uri=${encodedUri}`;
    window.location.href = url;
    
  }  

  return  <>        
        { auth.isAuthenticated && 
          <a href="#" className="ico-cerrar-sesion" title="Cerrar Sesión" onClick={logoutEvent}>Cerrar Sesión</a>
        }
    </>
}